import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { generateClient } from 'aws-amplify/api';
import { getUrl } from 'aws-amplify/storage';
import { listRecipes } from '../graphql/queries';

const client = generateClient();

export default function Timeline() {
  const navigate = useNavigate();
  const [recipes, setRecipes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [images, setImages] = useState({});

  useEffect(() => {
    async function loadRecipes() {
      try {
        const result = await client.graphql({
          query: listRecipes,
          variables: {
            filter: { isPublic: { eq: true } },
            limit: 50,
          }
        });
        const items = result.data.listRecipes.items
          .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
        setRecipes(items);

        // 画像URLを取得
        const imgMap = {};
        await Promise.all(items.map(async (r) => {
          if (r.imageUrl) {
            try {
              const urlResult = await getUrl({ key: r.imageUrl });
              imgMap[r.id] = urlResult.url.toString();
            } catch (e) {}
          }
        }));
        setImages(imgMap);
      } catch (err) {
        console.error('取得エラー:', err);
      } finally {
        setLoading(false);
      }
    }
    loadRecipes();
  }, []);

  const formatDate = (dateStr) => {
    const d = new Date(dateStr);
    return `${d.getFullYear()}/${d.getMonth() + 1}/${d.getDate()}`;
  };

  return (
    <div style={S.page}>
      <div style={S.container}>
        <div style={S.topBar}>
          <h1 style={S.heading}>🍽️ みんなのレシピ</h1>
          <button onClick={() => navigate('/recipe/create')} style={S.createBtn}>
            ＋ 作成
          </button>
        </div>

        {loading ? (
          <p style={{ textAlign: 'center', color: '#95a5a6', padding: '40px' }}>読み込み中...</p>
        ) : recipes.length === 0 ? (
          <div style={S.empty}>
            <p style={{ fontSize: '40px', margin: '0 0 10px' }}>🥘</p>
            <p style={{ color: '#95a5a6' }}>まだレシピがありません</p>
            <button onClick={() => navigate('/recipe/create')} style={S.createBtn}>
              最初のレシピを作る
            </button>
          </div>
        ) : (
          <div style={S.feed}>
            {recipes.map(recipe => (
              <div key={recipe.id} style={S.card} onClick={() => navigate(`/recipe/${recipe.id}`)}>
                {images[recipe.id] && (
                  <img src={images[recipe.id]} alt={recipe.title} style={S.cardImage} />
                )}
                <div style={S.cardBody}>
                  <h2 style={S.cardTitle}>{recipe.title}</h2>
                  {recipe.description && (
                    <p style={S.cardDesc}>
                      {recipe.description.length > 80 ? recipe.description.slice(0, 80) + '…' : recipe.description}
                    </p>
                  )}
                  <div style={S.cardMeta}>
                    <span style={S.metaItem}>👤 {recipe.owner?.split('::')[0] || '匿名'}</span>
                    <span style={S.metaItem}>📅 {formatDate(recipe.createdAt)}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

const S = {
  page: { padding: '80px 20px 40px', backgroundColor: '#f4f7f9', minHeight: '100vh' },
  container: { maxWidth: '600px', margin: '0 auto' },
  topBar: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '20px' },
  heading: { fontSize: '20px', fontWeight: '900', color: '#2c3e50', margin: 0 },
  createBtn: {
    padding: '10px 18px', borderRadius: '20px', border: 'none',
    background: '#e74c3c', color: '#fff', fontWeight: 'bold',
    fontSize: '14px', cursor: 'pointer',
  },
  empty: { textAlign: 'center', padding: '60px 20px' },
  feed: { display: 'flex', flexDirection: 'column', gap: '16px' },
  card: {
    background: '#fff', borderRadius: '16px', overflow: 'hidden',
    boxShadow: '0 2px 10px rgba(0,0,0,0.06)', cursor: 'pointer',
    transition: 'transform 0.2s, box-shadow 0.2s',
  },
  cardImage: { width: '100%', height: '180px', objectFit: 'cover' },
  cardBody: { padding: '16px' },
  cardTitle: { fontSize: '16px', fontWeight: '900', color: '#2c3e50', margin: '0 0 8px' },
  cardDesc: { fontSize: '13px', color: '#666', lineHeight: '1.6', margin: '0 0 12px' },
  cardMeta: { display: 'flex', gap: '14px' },
  metaItem: { fontSize: '12px', color: '#95a5a6' },
};
